import { useEffect, useState } from 'react'
import API from '../../../api'
import { getProductCategory } from '../../dive-guides/gtm-events'
import { convertCurrency } from '../../helpers'

let controller, signal

const useOtherActivities = (activityId, inViewport) => {
  const [isLoading, setIsLoading] = useState(true)
  const [activities, setActivities] = useState([])
  const [isShowPlaceholder, setIsShowPlaceholder] = useState(true)
  const [params, setParams] = useState({ limit: 8, offset: 0 })
  const [total, setTotal] = useState(0)

  useEffect(() => {
    fetchData()
    return () => {
      controller && controller.abort()
    }
  }, [inViewport, params])

  const fetchData = () => {
    if(!inViewport || !activityId) {
      return { activities }
    }
    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }
    setIsLoading(true)
    const filter = params
    API(`/api/adventure/v1/${activityId}/detail/other-activities/`, signal)
      .get(filter)
      .then(({ results, count }) => {
        setTotal(count)
        if(results.length) {
          results.forEach((product) => {
            const { type, productList } = getProductCategory(product.activityType)
            const { originCurrency, originValue } = product.minimumPrice
            product.viewItem = {
              item_name: product.titleEn || product.title,
              item_id: product.id.toString(),
              price: Number(convertCurrency(
                originValue,
                originCurrency,
                'USD',
              ).toFixed(2)),
              item_brand: 'PADI',
              item_category: 'PADI Travel',
              item_category2: type,
              item_list_name: productList,
            }
          })
          setActivities((prev) => [...prev, ...results])
        } else {
          const section = document.getElementById('other-adventures')

          if(section && !activities?.length) {
            section.setAttribute('hidden', true)
          }
        }
        setIsLoading(false)
        setIsShowPlaceholder(false)
      })
  }

  return {
    otherActivities: activities,
    isLoading,
    isShowPlaceholder,
    total,
    params,
    setParams,
    setIsShowPlaceholder,
    setIsLoading,
  }
}

export default useOtherActivities
